import type { ComponentProps } from 'react'
import { Building2, UserPlus } from 'lucide-react'
import type { WebModule } from '../core/index.js'
import { ClientList } from './admin/ClientList.js'
import { OnboardClientPage } from './admin/OnboardClientPage.js'

/** The admin area's home: the client list is the first page an admin sees, and a sales login's demos the first they see. */
export const CLIENTS_PATH = '/admin'
const ONBOARD_PATH = '/admin/onboard'

type Api = ComponentProps<typeof ClientList>['api'] & ComponentProps<typeof OnboardClientPage>['api']

/** What the clients module contributes to the shells: the client list and the onboarding form, for admins and, in their own words, for a sales login. */
export const clientsWebModule: WebModule<Api> = {
  name: 'clients',
  adminPages: [
    { path: CLIENTS_PATH, label: 'Clients', title: 'All Clients', icon: Building2, group: 'accounts', page: ({ api }) => <ClientList api={api} /> },
    // Reached from the client list, not the menu; the menu keeps Clients lit while it is open.
    {
      path: ONBOARD_PATH,
      label: 'Onboard a Client',
      title: 'Onboard a Client',
      icon: UserPlus,
      group: 'accounts',
      reachedFrom: { path: CLIENTS_PATH, label: 'All Clients' },
      page: ({ api }) => <OnboardClientPage api={api} />,
    },
    // The whole of a sales login's admin area: the demos it created, and the form that makes another. The API gives a sales
    // login nothing else, so this is the menu of what would work, not a way of hiding the rest.
    { path: CLIENTS_PATH, label: 'My Demos', title: 'My Demos', icon: Building2, group: 'demos', sales: true, page: ({ api }) => <ClientList api={api} /> },
    { path: ONBOARD_PATH, label: 'New Demo', title: 'New Demo', icon: UserPlus, group: 'demos', sales: true, page: ({ api }) => <OnboardClientPage api={api} demoOnly /> },
  ],
}
